<ng-container *transloco="let t">
  <form [formGroup]="inputForm">
    @if (isFirstRegistration) {
      <ng-container>
        @if (!isManagement) {
          <div class="col-12">
            <div class="select-item-group">
              <label for="raceId">{{ t('app.common.race') | titlecase }}<span>*</span></label>
              <app-select formControlName="raceId" [items]="raceListIds" [translatedLabels]="raceLabels"/>
            </div>
          </div>
        }
        @if (raceCommercialItems.length > 1) {
          <div class="col-12 pt-20-10">
            <div class="select-item-group">
              <label for="registrationFeeId">{{ t("race.pricing.registrationFees") | titlecase }}<span>*</span></label>
              <app-select formControlName="registrationFeeId"
                          [items]="raceCommercialItemsIds" [translatedLabels]="raceCommercialItemsLabels"/>
            </div>
          </div>
        }
        @if (isTeamRegistration) {
          <div class="col-12 pt-20-10">
            <app-input formControlName="teamName" label="app.common.team.name"/>
          </div>
        }
        @if (!isManagement && !isAdmin) {
          <div class="col-12 pt-20-10">
            <app-checkbox formControlName="registerForMySelf" label="app.register.to.race.forMySelf"
                          (click)="toggleRegisterForMySelf()"/>
          </div>
        }
        @if (displayReceiptEmail) {
          <div class="col-12 pt-20-10">
            <app-input formControlName="receiptEmail" label="app.common.receipt.email"
                       autocomplete="email"/>
          </div>
        }
      </ng-container>
    }
    <p class="large" [class.pt-3]="index == 0">
      {{ t('app.register.to.race.basic.data') | uppercase }}
    </p>
    <div class="row">
      @if (isRegistrationFieldUsed(applicationFormSettings?.emailRegistrationDisplayFlag)) {
        <div class="col-12">
          <app-input formControlName="email" label="app.common.email" autocomplete="email"/>
        </div>
      }
      <div class="col-12"
           [class.pt-20-10]="isRegistrationFieldUsed(applicationFormSettings?.emailRegistrationDisplayFlag)">
        <app-input formControlName="firstname" label="app.common.first.name" autocomplete="given-name"/>
      </div>
      <div class="col-12 pt-20-10">
        <app-input formControlName="lastname" label="app.common.last.name" autocomplete="family-name"/>
      </div>
      @if (genders.length > 0 &&
      isRegistrationFieldUsed(applicationFormSettings?.genderRegistrationDisplayFlag)) {
        <div class="col-12 pt-20-10">
          <app-select formControlName="gender" [items]="genders"
                      labelKeyPrefix="app.common.gender." label="app.common.gender" labelKey="id" valueKey="id"/>
        </div>
      }
      @if (isRegistrationFieldUsed(applicationFormSettings?.nicknameRegistrationDisplayFlag)) {
        <div class="col-12 pt-20-10">
          <app-input formControlName="nickname" label="app.common.nickname" autocomplete="nickname"/>
        </div>
      }
      @if (isRegistrationFieldUsed(applicationFormSettings?.birthdayRegistrationDisplayFlag)) {
        <div class="col-12 pt-20-10">
          <app-date-time-input formControlName="birthday" [displayTime]="false" [openDate]="calendarNavigationDate"
                               [label]="t('app.common.birthDay') | titlecase" [allowOnlyYearSelection]="isAdmin"
                               [minDate]="minDateForBirthday" [maxDate]="currentDate"/>
        </div>
      }
      @if (isRegistrationFieldUsed(applicationFormSettings?.addressRegistrationDisplayFlag)) {
        <div class="col-12 pt-20-10">
          <app-input formControlName="address" label="app.common.address"
                     autocomplete="street-address"/>
        </div>
      }
      @if (isRegistrationFieldUsed(applicationFormSettings?.cityRegistrationDisplayFlag)) {
        <div class="col-12 pt-20-10">
          <app-input formControlName="city" label="app.common.placeOfResidence"/>
        </div>
      }
      @if (countries.length > 0 &&
      isRegistrationFieldUsed(applicationFormSettings?.countryRegistrationDisplayFlag)) {
        <div class="col-12 pt-20-10">
          <app-select formControlName="country" [items]="countries"
                      labelKey="id" labelKeyPrefix="app.common.country."
                      valueKey="id" autocomplete="country" label="app.common.country"/>
        </div>
      }
      @if (countries.length > 0 &&
      isRegistrationFieldUsed(applicationFormSettings?.nationalityRegistrationDisplayFlag)) {
        <div class="col-12 pt-20-10">
          <app-select formControlName="nationality" [items]="countries"
                      labelKey="name" valueKey="id" autocomplete="country" label="app.common.nationality"/>
        </div>
      }
      @if (isRegistrationFieldUsed(applicationFormSettings?.identityCardNumberRegistrationDisplayFlag)) {
        <div class="col-12 pt-20-10">
          <app-input formControlName="identityCardNumber" label="app.common.identityCardNumber"/>
        </div>
      }
      @if (isRegistrationFieldUsed(applicationFormSettings?.identityCardIssuerRegistrationDisplayFlag)) {
        <div class="col-12 pt-20-10">
          <app-input formControlName="identityCardIssuer" label="app.common.identityCardIssuer"/>
        </div>
      }
      @if (isRegistrationFieldUsed(applicationFormSettings?.identityCardExpiresRegistrationDisplayFlag)) {
        <div class="col-12 pt-20-10">
          <app-date-time-input formControlName="identityCardExpires" [displayTime]="false"
                               [label]="t('app.common.identityCardExpires')"
                               [minDate]="currentDate"/>
        </div>
      }
      @if (isRegistrationFieldUsed(applicationFormSettings?.emergencyPhoneRegistrationDisplayFlag)) {
        <div class="col-12 pt-20-10">
          <app-tel-input [formControlName]="'emergencyPhone'"
                         [label]="getInputFieldPlaceholder('app.common.emergencyPhone', 'emergencyPhone')"
                         [numberPlaceholder]="getInputFieldPlaceholder('app.common.emergencyPhone', 'emergencyPhone')"></app-tel-input>
        </div>
      }
      @if (isRegistrationFieldUsed(applicationFormSettings?.mobilePhoneRegistrationDisplayFlag)) {
        <div class="col-12 pt-20-10">
          <app-tel-input [formControlName]="'mobilePhone'"
                         [label]="getInputFieldPlaceholder('app.common.mobilePhone',  'mobilePhone')"
                         [numberPlaceholder]="getInputFieldPlaceholder('app.common.mobilePhone',  'mobilePhone')"></app-tel-input>


        </div>
      }

      @if (isRegistrationFieldUsed(applicationFormSettings?.clubRegistrationDisplayFlag)) {
        <div class="col-12 pt-20-10">
          <app-input formControlName="club" label="app.common.club"/>
        </div>
      }
      @if (isRegistrationFieldUsed(applicationFormSettings?.bestTimeRegistrationDisplayFlag)) {
        <div class="col-12 pt-20-10">
          <app-input formControlName="bestTime" label="app.common.bestTime"/>
        </div>
      }
      @if (shouldShowTitle()) {
        <div class="pt-4">
          <p class="large text-uppercase">
            {{ t('app.register.to.race.additional.data') | uppercase }}
          </p>
        </div>
      }
      @if (tshirtSizes.length > 0 &&
      isRegistrationFieldUsed(applicationFormSettings?.tshirtRegistrationDisplayFlag)) {
        <div class="col-12 pt-20-10">
          <app-select formControlName="tshirtSize" [items]="tshirtSizes"
                      labelKey="name" valueKey="alternativeId" label="app.common.tshirtSize"/>
        </div>
      }
      @if (meals.length > 0 && isRegistrationFieldUsed(applicationFormSettings?.mealRegistrationDisplayFlag)) {
        <div class="col-12 pt-20-10">
          <app-select formControlName="meal" [items]="meals" labelKey="alternativeId" labelKeyPrefix="app.common.meal."
                      valueKey="alternativeId" label="app.common.meal"/>
        </div>
      }

      @if (transports.length
      > 0 && isRegistrationFieldUsed(applicationFormSettings?.transportRegistrationDisplayFlag)) {
        <div class="col-12 pt-20-10">
          <app-select formControlName="transport" [items]="transports"
                      labelKey="id" valueKey="alternativeId"  labelKeyPrefix="app.common.transport." label="app.common.transport"/>
        </div>
      }
      @if (isRegistrationFieldUsed(applicationFormSettings?.chipNumberRegistrationDisplayFlag)) {
        <div class="col-12 pt-20-10">
          <app-input formControlName="chipNumber" label="app.common.chipNumber"/>
        </div>
      }
      @if (isRegistrationFieldUsed(applicationFormSettings?.licenceRegistrationDisplayFlag)) {
        <div class="col-12 pt-20-10">
          <app-input formControlName="licence" label="app.common.licence"/>
        </div>
      }
      @if (disciplines.length > 0 &&
      isRegistrationFieldUsed(applicationFormSettings?.disciplineRegistrationDisplayFlag)) {
        <div class="col-12 pt-20-10">
          <app-select formControlName="discipline" [items]="disciplines"
                      labelKey="name" valueKey="id" label="app.common.discipline"/>
        </div>
      }
      @for (field of customFields;track field.id) {
        <div class="col-12 pt-20-10">
          <app-field-config-value-input [inputForm]="inputForm.controls.customFieldValues" [fieldConfig]="field"
                                        [fieldKey]="field.id?.toString() ?? ''"/>
        </div>
      }
      @for (item of raceAdditionalItems;track $index) {
        <div class="col-12 pt-20-10">
          <ng-container formArrayName="raceAdditionalPricingItems">
            <ng-container [formGroupName]="$index">
              <app-additional-pricing-item-value-input [inputForm]="raceAdditionalPricingItemFormControl($index)"
                                                       [fieldConfig]="item" [event]="event" [currencies]="currencies"
                                                       [fieldKey]="'racePricingItemValue'"/>
            </ng-container>
          </ng-container>
        </div>
      }
      @if (isRegistrationFieldUsed(applicationFormSettings?.commentRegistrationDisplayFlag)) {
        <div class="col-12 pt-20-10">
          <app-input formControlName="comment" label="app.common.comment"/>
        </div>
      }
      @if (registerToRaceComponentState === registerToRaceComponentStateType.ERROR) {
        <div class="col-12">
          <div class="pt-4">
            <span class="error-message">{{ t('app.register.to.race.error') }}</span>
          </div>
        </div>
      }
    </div>

    @if (isAdmin && !isManagement && ((isTeamRegistration && isFirstRegistration) || !isTeamRegistration)) {
    <p class="large" [class.pt-3]="index == 0">
      {{ t('app.register.to.race.start.data') | uppercase }}
    </p>
    <div class="row">
      @if (race?.raceSettings?.blockStart) {
      <div class="col-12 pt-20-10">
          <app-input formControlName="startBlock" label="competitor.table.startBlock" type="number"></app-input>
      </div>
      }
      <div class="col-12 pt-20-10">
        <app-input formControlName="startNumber" label="competitor.table.start.number"></app-input>
      </div>
      <div class="col-12 pt-20-10">
        <app-checkbox formControlName="presentAtStart" label="competitor.table.presentAtStart" />
      </div>
    </div>
    }
  </form>
</ng-container>
